var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _ellipse, _ellipse2, _path9, _path0, _path1, _path10, _ellipse3, _path11, _path12, _rect3, _circle2, _path13, _circle3, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAckFibo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 212,
    viewBox: "0 0 202 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.048 124.729C187.048 124.729 210.643 161.311 195.791 165.774C180.939 170.237 173.763 151.428 173.763 151.428",
    fill: "#F8A63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.048 124.729C187.048 124.729 210.643 161.311 195.791 165.774C180.939 170.237 173.763 151.428 173.763 151.428",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.7207,
    y: 171.999,
    width: 19.504,
    height: 39.002,
    rx: 9.75202,
    transform: "rotate(-0.29 88.7207 171.999)",
    fill: "#F8A63F",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 135.867,
    y: 171.759,
    width: 19.504,
    height: 39.002,
    rx: 9.75202,
    transform: "rotate(-0.29 135.867 171.759)",
    fill: "#F8A63F",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.009 75.3265C158.009 75.3265 172.19 71.9793 179.872 75.168C187.554 78.3567 181.61 104.97 181.61 104.97",
    fill: "#F8A63F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.009 75.3265C158.009 75.3265 172.19 71.9793 179.872 75.168C187.554 78.3567 181.61 104.97 181.61 104.97",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2299 76.2832C88.2299 76.2832 70.9452 72.4909 63.2935 75.7589C55.6419 79.0268 61.2145 100.512 61.2145 100.512",
    fill: "#F8A63F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2299 76.2832C88.2299 76.2832 70.9452 72.4909 63.2935 75.7589C55.6419 79.0268 61.2145 100.512 61.2145 100.512",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.861,
    cy: 129.644,
    r: 66.1881,
    fill: "#F8A63F",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.393 114.499C111.393 114.499 114.368 126.345 120.77 126.308C127.171 126.272 130.177 114.816 130.177 114.816",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.447 108.719C104.276 113.779 112.416 116.797 120.464 112.377C128.743 116.474 136.377 114.017 132.505 108.573",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.54,
    cy: 101.744,
    rx: 4.85314,
    ry: 7.69431,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.181,
    cy: 101.744,
    rx: 4.85314,
    ry: 7.69431,
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4377 111.523L78.3589 115.943",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3274 111.523L86.2485 115.943",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M154.089 111.523L150.01 115.943",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.972 111.523L157.893 115.943",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.335,
    cy: 81.1136,
    rx: 5.42016,
    ry: 9.90749,
    transform: "rotate(-61.79 148.335 81.1136)",
    fill: "#F8A63F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2575 153.886C59.2575 153.886 23.3711 112.811 37.9732 107.586C52.5753 102.361 69.8174 125.303 69.8174 125.303",
    fill: "#F8A63F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2575 153.886C59.2575 153.886 23.3711 112.811 37.9732 107.586C52.5753 102.361 69.8174 125.303 69.8174 125.303",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.0942,
    y: 61.3595,
    width: 15.2423,
    height: 76.8211,
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7154,
    cy: 39.7154,
    r: 38.7154,
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4199 112.214C33.9804 105.861 50.692 105.508 52.4236 110.617C53.7527 114.531 51.4359 124.725 38.6019 129.42C29.0297 132.926 24.0485 119.689 29.4199 112.214Z",
    fill: "#F8A63F",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4962,
    cy: 39.7155,
    r: 28.3507,
    fill: "#079F9F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27 43.1773L32.8259 46.887C34.1927 47.7573 36.175 47.6282 37.3459 46.5927L52.607 32",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAckFibo);
export default __webpack_public_path__ + "static/media/ackFibo.4166de7167b52f17e7f149b5e3847838.svg";
export { ForwardRef as ReactComponent };